<template>
  <overlay-scrollbars id="search-result-normal" :options="{ className: 'modal-window-body no-padding active os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
    <div class="item-list-objekt large-padding" id="topbar-search-results">
      <!-- Objekt -->
      <template v-if="result.objekt.total && (filter === 'objekt' || !filter)">
        <span class="item-list-heading" v-if="result.objekt.total > 1">
          {{result.objekt.total}} objekter
        </span>
        <span class="item-list-heading" v-else>
          1 objekt
        </span>

        <ul class="all object">
          <li v-for="item in result.objekt.objektData" v-bind:key="'object.' + item.Objektid">

            <a href="javascript:;" @click="toggleActionsPopover('objekt' + item.Objektid)" class="item-link">
              <span class="item-icon gray"><svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-object"></use></svg></span>
              <span class="thumbnail small placeholder animation">
                <template v-if="objektThumb(item) && objektLarge(item)">
                  <img class="hi-trigger" :src="objektThumb(item)" :data-hi-src-full="objektLarge(item)" data-hi-size="large" />
                </template>
                <template v-else-if="objektThumb(item)">
                  <img :src="objektThumb(item)" />
                </template>
                <template v-else>
                  <span class="placeholder"></span>
                </template>
              </span>
              <span class="item-title">
                <span class="title">{{objektTitle(item) | truncate(40)}}</span>
                <span class="subtitle">{{item.Objektnr}}</span>
                <span class="subtitle" style="display: none;">Score: {{item._score}}</span>
              </span>
            </a>
            <span class="has-popover" :class="{'popover-active': actionsPopoverActive.hasOwnProperty('objekt' + item.Objektid)}" :data-objektid="item.Objektid" @click="toggleActionsPopover('objekt' + item.Objektid)" style="left: 25px;z-index: 99999;position:abso">
              <span class="popover  medium" style="display:flex; width: 350px;" >
                <ul>
                  <li><a href="javascript:;" @click="loadObjektModal(item.Objektid)"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-visible"></use></svg> <span>Vis objekt</span></a></li>
                  <li :class="{'disabled' : !(item.Kontraktnr && item.kontrakt && item.kontrakt.Kundenr)}"><a :href="objektKontraktLink(item)" ><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-contract"></use></svg> <span>Vis kontrakt</span></a></li>
                  <li :class="{'disabled' : !(item.mottaker && item.mottaker.Kundenr)}"><a :href="objektKundeLink(item)" ><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-person"></use></svg> <span>Vis Kjøper</span></a></li>
                  <li :class="{'disabled' : !(item.innlevav && item.innlevav.Kundenr)}"><a :href="objektSelgerLink(item)" ><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-person"></use></svg> <span>Vis selger</span></a></li>
                  <li v-if="item.kunstner && item.kunstner.Idnr"><a @click="openKunstnerObjektListModal(item.kunstner)"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-object"></use></svg> <span>Kunstnerens objekter</span></a></li>
                </ul>
                <span>
                   <div class="data-grid" style="margin-bottom: 0; ">
                     <div class="grid-x grid-padding-x grid-padding-small hover-card" :class="{'active': actionsPopoverActive.hasOwnProperty('objekt' + item.Objektid)}" style="width:200px; position: relative;">
                       <div class="cell border-bottom hover-card-header" style="padding-bottom: 1rem;padding-top: 1rem;">
                         <span class="hover-card-content">
                           <span class="item-title">
                             <span class="title data-hc-title">{{objektTitle(item)}}</span>
                             <span class="subtitle data-hc-subtitle">{{item.Objektnr}}</span>
                             <span class="subtitle data-hc-count">Antall: {{item.Antall !== undefined ? item.Antall : '-'}}</span>
                           </span>
                         </span>
                       </div>

                       <div class="cell large-6 border-bottom">
                         <div class="dl-wrap">
                           <span class="dl dt" style="width: 100px">Lav vurdering</span>
                           <span class="dl dd data-hc-price-low">{{objektVurderingLow(item)}}</span>
                         </div>
                       </div>

                       <div class="cell large-6 border-bottom">
                         <div class="dl-wrap">
                           <span class="dl dt" style="width: 100px">Høy vurdering</span>
                           <span class="dl dd data-hc-price-high">{{objektVurderingHigh(item)}}</span>
                         </div>
                       </div>

                       <div class="cell large-6">
                         <div class="dl-wrap">
                           <span class="dl dt">Minstepris</span>
                           <span class="dl dd data-hc-price-min">{{objektMinstepris(item)}}</span>
                         </div>
                       </div>

                       <div class="cell large-6">
                         <div class="dl-wrap">
                           <span class="dl dt">Tilslag</span>
                           <span class="dl dd data-hc-sold">{{objektTilslag(item)}}</span>
                         </div>
                       </div>
                     </div>
                   </div>
                 </span>
              </span>
            </span>
          </li>
          <li v-if="result.objekt.pages > 1">
            <div class="load-more">
              <button v-if="result.objekt.page < result.objekt.pages && !result.objekt.updating" href="javascript:;" class="button secondary action glyph" @click="loadMore('objekt')">
                <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-add"></use></svg>
                Last fler...
              </button>
              <button v-else-if="result.objekt.updating" href="javascript:;" class="button secondary action glyph loading">
                <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-add"></use></svg>
                <span>Laster fler <span class="loader-spinner"></span></span>
              </button>
              <div v-else class="finished">
                Alt har blitt lastet inn...
              </div>
            </div>
          </li>
        </ul>
      </template>

      <!-- Kunde -->
      <template v-if="result.kunde.total && (filter === 'kunde' || !filter)">
        <span class="item-list-heading all object" v-if="result.kunde.total > 1">
          {{result.kunde.total}} kunder
        </span>
        <span class="item-list-heading all object" v-else>
          1 kunde
        </span>

        <ul class="all customer">
          <li v-for="item in result.kunde.items" v-bind:key="'kunde.' + item.Kundenr">
            <router-link :to="kundeLink(item)" @click.native="beforeLeave" class="item-link">
              <span class="item-icon gray"><svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-user"></use></svg></span>
              <span class="item-title">
                <span class="title" style="color: red;" v-if="item.Sperret === 'T'">{{item.Bedrift === true ? item.FirmaNavn : item.full_name}} (sperret)</span>
                <span class="title" v-else>{{item.Bedrift === true ? item.FirmaNavn : item.full_name}}</span>
                <span class="subtitle">{{item.Kundenr}}</span>
                <span class="subtitle">{{kundeSubtitle(item) | truncate(55)}}</span>
              </span>
            </router-link>
            <router-link :to="kundeLink(item)" @click.native="beforeLeave" class="item-new-window-button">
              <span>Nytt vindu</span>
              <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-new-window"></use></svg>
            </router-link>
          </li>
          <li v-if="result.kunde.pages > 1">
            <div class="load-more">
              <button v-if="result.kunde.page < result.kunde.pages && !result.kunde.updating" href="javascript:;" class="button secondary action glyph" @click="loadMore('kunde')">
                <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-add"></use></svg>
                Last fler...
              </button>
              <button v-else-if="result.kunde.updating" href="javascript:;" class="button secondary action glyph loading">
                <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-add"></use></svg>
                <span>Laster fler <span class="loader-spinner"></span></span>
              </button>
              <div v-else class="finished">
                Alt har blitt lastet inn...
              </div>
            </div>
          </li>
        </ul>

        <div class="divider all"></div>
      </template>

      <!-- Kunstner -->
      <template v-if="result.kunstner.total && (filter === 'kunstner' || !filter)">
        <span class="item-list-heading" v-if="result.kunstner.total !== 1">
          {{result.kunstner.total}} kunstnere i registeret
        </span>
        <span class="item-list-heading" v-else>
          1 kunstner i registeret
        </span>

        <ul class="all artist">
          <li v-for="item in result.kunstner.items" v-bind:key="'kunstner.' + item.Idnr">
            <a href="javascript:;" @click="openKunstnerModal(item)" class="item-link">
              <span class="item-icon gray"><svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-artist"></use></svg></span>
              <span class="item-title">
                <span class="title">{{item.Navn}}</span>
                <span class="subtitle">{{item.Periode | truncate(55)}}</span>
              </span>
            </a>
            <span class="button-container has-popover" :class="{'popover-active': actionsPopoverActive.hasOwnProperty('kunstner' + item.Idnr)}" :data-kunstnerid="item.Idnr" @click="toggleActionsPopover('kunstner' + item.Idnr)">
              <a class="item-more-button" href="javascript:;"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-more"></use></svg></a>
              <span class="popover align-x-right align-y-bottom small">
                <ul>
                  <li><a @click="openKunstnerModal(item)"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-person"></use></svg> <span>Vis kunstner</span></a></li>
                  <li><a @click="openKunstnerObjektListModal(item)"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-contract"></use></svg> <span>Vis objekter</span></a></li>
                </ul>
              </span>
            </span>
          </li>
          <li v-if="result.kunstner.pages > 1">
            <div class="load-more">
              <button v-if="result.kunstner.page < result.kunstner.pages && !result.kunstner.updating" href="javascript:;" class="button secondary action glyph" @click="loadMore('kunstner')">
                <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-add"></use></svg>
                Last fler...
              </button>
              <button v-else-if="result.kunstner.updating" href="javascript:;" class="button secondary action glyph loading">
                <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-add"></use></svg>
                <span>Laster fler <span class="loader-spinner"></span></span>
              </button>
              <div v-else class="finished">
                Alt har blitt lastet inn...
              </div>
            </div>
          </li>
        </ul>
      </template>

      <!-- Faktura -->
      <template v-if="result.faktura.total && (filter === 'faktura' || !filter)">
        <span class="item-list-heading all object" v-if="result.faktura.total > 1">
          {{result.faktura.total}} fakturaer
        </span>
        <span class="item-list-heading all object" v-else>
          1 faktura
        </span>

        <ul class="all customer">
          <li v-for="item in result.faktura.items" v-bind:key="'kunde.' + item.Kundenr">
            <a href="javascript:;" class="item-link" @click="showBilagsPdf(item)">
              <span class="item-icon gray"><svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-invoice"></use></svg></span>
              <span class="item-title">
                <span class="title" v-if="item.twentyfourseven_invoice_id && item.Dato > '2019-12-31'">{{item.twentyfourseven_invoice_id}}, {{item.Bilagsart === 'K' ? 'Oppgjør' : 'Kjøper'}}</span>
                <span class="title" v-else>{{item.Bilagsnr}}, {{item.Bilagsart === 'K' ? 'Oppgjør' : 'Kjøper'}}</span>

                <span class="subtitle" v-if="item.avdeling && item.bilagstype">{{item.avdeling.Beskrivelse}} / {{item.bilagstype.info}}</span>

                <template v-if="item.kunde">
                  <span class="subtitle" v-if="item.kunde.Bedrift">{{item.kunde.FirmaNavn ? item.kunde.FirmaNavn : (item.kunde.full_name || '-')}} / {{item.kunde.Kundenr}}</span>
                  <span class="subtitle" v-else>{{item.kunde.full_name || '-'}} / {{item.kunde.Kundenr}}</span>
                </template>
              </span>
            </a>
            <span class="button-container has-popover" :class="{'popover-active': actionsPopoverActive.hasOwnProperty('faktura' + item.Bilagsid)}" :data-fakturaid="item.Bilagsid" @click="toggleActionsPopover('faktura' + item.Bilagsid)">
              <a class="item-more-button" href="javascript:;"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-more"></use></svg></a>
              <span class="popover align-x-right align-y-bottom small">
                <ul>
                  <li><a href="javascript:;" @click="openKundeInvoicesLink(item.kunde)"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-person"></use></svg> <span>Vis kunde</span></a></li>
                  <li><a href="javascript:;" @click="showBilagsPdf(item)"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-invoice"></use></svg> <span>Vis faktura</span></a></li>
                </ul>
              </span>
            </span>
          </li>
          <li v-if="result.faktura.pages > 1">
            <div class="load-more">
              <button v-if="result.faktura.page < result.faktura.pages && !result.faktura.updating" href="javascript:;" class="button secondary action glyph" @click="loadMore('faktura')">
                <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-add"></use></svg>
                Last fler...
              </button>
              <button v-else-if="result.kunde.updating" href="javascript:;" class="button secondary action glyph loading">
                <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-add"></use></svg>
                <span>Laster fler <span class="loader-spinner"></span></span>
              </button>
              <div v-else class="finished">
                Alt har blitt lastet inn...
              </div>
            </div>
          </li>
        </ul>

        <div class="divider all"></div>
      </template>

      <!-- Kontrakt -->
      <template v-if="result.kontrakt.total && (filter === 'kontrakt' || !filter)">
        <span class="item-list-heading all object" v-if="result.kontrakt.total > 1">
          {{result.kontrakt.total}} kontrakter
        </span>
        <span class="item-list-heading all object" v-else>
          1 kontrakt
        </span>

        <ul class="all customer">
          <li v-for="item in result.kontrakt.items" v-bind:key="'kunde.' + item.Kontraktnr">
            <router-link :to="kontraktLink(item)" @click.native="beforeLeave" class="item-link">
              <span class="item-icon gray"><svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-contract"></use></svg></span>
              <span class="item-title">
                <span class="title">{{item.Kontraktnr}}<template v-if="item.avdeling">, {{item.avdeling.Beskrivelse}}</template></span>
                <template v-if="item.kunde">
                  <span class="subtitle" v-if="item.kunde.Bedrift">{{item.kunde.FirmaNavn ? item.kunde.FirmaNavn : (item.kunde.full_name || '-')}} / {{item.kunde.Kundenr}}</span>
                  <span class="subtitle" v-else>{{item.kunde.full_name || '-'}} / {{item.kunde.Kundenr}}</span>
                </template>
              </span>
            </router-link>

          </li>
          <li v-if="result.kontrakt.pages > 1">
            <div class="load-more">
              <button v-if="result.kontrakt.page < result.kontrakt.pages && !result.kontrakt.updating" href="javascript:;" class="button secondary action glyph" @click="loadMore('kontrakt')">
                <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-add"></use></svg>
                Last fler...
              </button>
              <button v-else-if="result.kontrakt.updating" href="javascript:;" class="button secondary action glyph loading">
                <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-add"></use></svg>
                <span>Laster fler <span class="loader-spinner"></span></span>
              </button>
              <div v-else class="finished">
                Alt har blitt lastet inn...
              </div>
            </div>
          </li>
        </ul>

        <div class="divider all"></div>
      </template>
    </div>
  </overlay-scrollbars>
</template>

<script>
import accounting from 'accounting-js'
import bus from '@/plugins/event-bus'

export default {
  name: 'TheMainSearchNormalResult',
  props: {
    filter: {
      type: String,
      required: false,
      default () {
        return ''
      }
    },
    result: {
      type: Object,
      required: false,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      actionsPopoverActive: {}
    }
  },
  watch: {
    filter: function (newVal) {
      if (undefined !== newVal) {
        window.jQuery('.os-viewport', window.jQuery('#search-result-normal')).scrollTop(0)
      }
    }
  },
  methods: {
    beforeLeave: function () {
      window.jQuery('#hi-container').removeClass('active')
      window.jQuery(document).unbind('mousemove')

      bus.$emit('before-leave-page')
    },
    loadMore: function (type) {
      bus.$emit('load-more', type)
    },
    toggleActionsPopover: function (Objektid) {
      if (this.actionsPopoverActive.hasOwnProperty(Objektid)) {
        this.$delete(this.actionsPopoverActive, Objektid)
      } else {
        this.$set(this, 'actionsPopoverActive', {})
        this.$set(this.actionsPopoverActive, Objektid, 1)
      }
    },
    objektTitle: function (item) {
      if (item.kunstner && item.kunstner.Navn) {
        return item.kunstner.Navn + (item.Katalogtekst1 ? ' / ' + item.Katalogtekst1 : '')
      } else if (item.Kunstner) {
        return item.Kunstner + (item.Katalogtekst1 ? ' / ' + item.Katalogtekst1 : '')
      } else if (item.Katalogtekst1) {
        return item.Katalogtekst1
      } else {
        return ''
      }
    },
    objektVurderingLow: function (item) {
      if (item.Vurderingspris2 > 0) {
        return accounting.formatNumber(item.Vurderingspris2, { precision: 0, thousand: ' ' })
      } else if (item.Vurderingspris2 === '0' || item.Vurderingspris2 === 0) {
        return '0'
      }

      return '-'
    },
    objektVurderingHigh: function (item) {
      if (item.Vurderingspris1 > 0) {
        return accounting.formatNumber(item.Vurderingspris1, { precision: 0, thousand: ' ' })
      } else if (item.Vurderingspris1 === '0' || item.Vurderingspris1 === 0) {
        return '0'
      }

      return '-'
    },
    objektMinstepris: function (item) {
      if (item.Minstepris > 0) {
        return accounting.formatNumber(item.Minstepris, { precision: 0, thousand: ' ' })
      } else if (item.Minstepris === '0' || item.Minstepris === 0) {
        return '0'
      }

      return '-'
    },
    objektTilslag: function (item) {
      if (this._.startsWith(item.Auksjon, 'AR')) {
        return 'Usolgt'
      } else if (item.Salgspris > 0) {
        return accounting.formatNumber(item.Salgspris, { precision: 0, thousand: ' ' })
      } else if (item.Salgspris === '0' || item.Salgspris === 0) {
        return '0'
      }

      return '-'
    },
    objektThumb: function (item) {
      if (item.photos && item.photos.thumb && item.photos.thumb.length > 0) {
        return item.photos.thumb[0]
      }

      return null
    },
    objektLarge: function (item) {
      if (item.photos && item.photos.large && item.photos.large.length > 0) {
        return item.photos.large[0]
      }

      return null
    },
    objektLink: function (item) {
      if (!item.innlevav) {
        return null
      }
      return '/kunde/' + item.kontrakt.Kundenr + '?kontrakt=' + item.Kontraktnr + '&objekt=' + item.Objektid + '&searchResult=true&advanced=false'
    },
    objektKontraktLink: function (item) {
      if ((item.Kontraktnr && item.kontrakt && item.kontrakt.Kundenr)) {
        return '/kunde/' + item.kontrakt.Kundenr + '?kontrakt=' + item.Kontraktnr + '&searchResult=true&advanced=false'
      }
      return 'javascript:;'
    },
    objektKundeLink: function (item) {
      if ((item.mottaker && item.mottaker.Kundenr)) {
        return '/kunde/' + item.mottaker.Kundenr + '?searchResult=true&advanced=false'
      }
      return 'javascript:;'
    },
    objektSelgerLink: function (item) {
      if ((item.innlevav && item.innlevav.Kundenr)) {
        return '/kunde/' + item.innlevav.Kundenr
      }
      return 'javascript:;'
    },
    kundeSubtitle: function (item) {
      let array = []
      if (item.Email) {
        array.push(item.Email)
      }
      if (item.Mobil) {
        array.push(item.Mobil)
      } else if (item.Tlfprivat) {
        array.push(item.Tlfprivat)
      } else if (item.Tlfarbeid) {
        array.push(item.Tlfarbeid)
      }

      return array.length > 0 ? array.join(', ') : ''
    },
    kundeLink: function (item) {
      return {
        name: 'KundeCard',
        params: {
          kunde_id: item.Kundenr
        }
      }
    },
    kontraktLink: function (item) {
      return '/kunde/' + item.Kundenr + '?kontrakt=' + item.Kontraktnr
    },
    openKundeInvoicesLink: function (item) {
      sessionStorage.showKundeTab = 'faktura'

      const link = {
        name: 'KundeCard',
        params: {
          kunde_id: item.Kundenr
        }
      }

      this.beforeLeave()
      this.$router.push(link)
    },
    openKunstnerModal: function (item) {
      if (item) {
        this.openModal('kunstner-form-modal', { kunstnerIdentifier: item.Idnr })
      }
    },
    openKunstnerObjektListModal: function (item) {
      if (item) {
        this.openModal('kunstner-objekt-list-modal', { kunstner: item, internalWindow: true }, 'large')
      }
    },
    showBilagsPdf: function (item) {
      this.openModal('bilag-pdf-modal', { bilag: item, internalWindow: true }, 'split')
    }
  }
}
</script>
<style scoped>
  div.load-more {
    width: 100%;
    text-align: center;
    margin-top: 10px;
  }

  div.load-more button:focus {
    outline:0;
  }

  div.load-more .finished {
    width: 100%; text-align: center; margin-top: 10px; font-size: 0.8em;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/TheMainSearchNormalResult.vue